import React, { useRef, useLayoutEffect } from 'react'
import { Box } from '@mui/material'
import PopularGames from './popularGames/popularGames'
import NewlyLaunched from './newlyLaunched/newlyLaunched'
import LiveGames from './liveGames/liveGames'
export const Games = (props) => {
    const sectionRef = useRef(null);
    const newlyAddedSectionRef = useRef(null);
    const liveSectionRef = useRef(null);

    return (
        <Box>
          {/* Popular games Section  */}
          <Box ref={sectionRef} sx={{ width: "100%", position: "relative", zIndex: 6, bgcolor: "#fff" }}>
              <PopularGames {...props} />
          </Box>

          {/* Newly Added Section */}
          <Box ref={newlyAddedSectionRef} sx={{ width: "100%", position: "relative", zIndex: 8, bgcolor: "#fff" }}>
            <NewlyLaunched />
          </Box>
     
          {/* Live Games Section */}
           <Box ref={liveSectionRef} sx={{ width: "100%", position: "relative", zIndex: 10, bgcolor: "#fff" }}>
             <LiveGames {...props} />
           </Box>
        </Box>
    )
}